// ============================================================================
// REGISTRATION STATUS TIMELINE (ADR-0048 §1 amended) — whether the entity charges
// tax under its jurisdiction, effective-dated and append-only. Entity-scoped via
// X-Entity-ID: a unit differs only in which registration it issues under.
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { taxRegistrationStatusEndpoints } from '../endpoints/tax.endpoints';
import type {
  ApiResponse, TaxRegistrationStatusDto, SetTaxRegistrationStatusRequest, CorrectTaxRegistrationStatusDateRequest,
} from '../types';

class TaxRegistrationStatusService {
  /** Null when the entity has no jurisdiction (the API answers 404). */
  async get(): Promise<TaxRegistrationStatusDto | null> {
    try {
      const r = await get<ApiResponse<TaxRegistrationStatusDto>>(taxRegistrationStatusEndpoints.get());
      return r.data.data ?? null;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  }

  /** Append a status change (or the first answer). */
  async set(request: SetTaxRegistrationStatusRequest): Promise<TaxRegistrationStatusDto> {
    const r = await post<ApiResponse<TaxRegistrationStatusDto>>(taxRegistrationStatusEndpoints.set(), request);
    return r.data.data;
  }

  /** Correct the latest row's date (while no document sits on or after it). */
  async correctLatestDate(request: CorrectTaxRegistrationStatusDateRequest): Promise<TaxRegistrationStatusDto> {
    const r = await put<ApiResponse<TaxRegistrationStatusDto>>(taxRegistrationStatusEndpoints.latest(), request);
    return r.data.data;
  }

  /** Remove the latest row (undo a mistaken change). */
  async deleteLatest(rowVersion: number): Promise<TaxRegistrationStatusDto> {
    const r = await del<ApiResponse<TaxRegistrationStatusDto>>(`${taxRegistrationStatusEndpoints.latest()}?rowVersion=${rowVersion}`);
    return r.data.data;
  }
}

export const taxRegistrationStatusService = new TaxRegistrationStatusService();
export default taxRegistrationStatusService;
